import React from 'react'
import skillPathInactive from 'assets/learningPaths/skillPathInactive.svg';
import skillPathsCompletedInactive from 'assets/learningPaths/skillPathCompletedInactive.svg';
import styles from './Common.module.scss';

const EmptySkillPathsStates = ({isCompleted = false, copy = '', subCopy = ''}) => {
  return (
    <div className={styles.EmptyStateContainer}>
        <img src={isCompleted ? skillPathsCompletedInactive: skillPathInactive} alt=''/>
        <div className={styles.EmptyStateContainerCopy}>{copy}</div>
        <div className={styles.EmptyStateContainerSubCopy}>{subCopy}</div>
    </div>
  )
}

export default EmptySkillPathsStates